<template>
  <v-main class="grey lighten-3">
    <div
      id="core-view"
      style="padding-left:10px; padding-right:10px;padding-bottom: 100px;"
    >
      <div
        style="margin: 50px auto; display:flex"
        class="justify-center"
        v-if="loading"
      >
        <div class="align-self-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="accent"
            indeterminate
          ></v-progress-circular>
        </div>
      </div>
      <router-view v-else />
    </div>
  </v-main>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CoreView",
  data() {
    return {
      loading: false,
    };
  },
  metaInfo() {
    return {
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
  },
  mounted() {
    let timeout = undefined;
    this.$router.afterEach((to, from) => {
      this.loading = false;
    });
    this.$router.beforeHooks.unshift((to, from, next) => {
      this.loading = true;
      next();
    });
    this.$router.onError(() => {
      console.log("error");
      this.loading = false;
      document.title = this.$t("globals.app_title");
    });
  },
};
</script>
